// ROW 1 — PHOTO (morphs in when a photo is selected; icons get their own
// iconRow1). R2: the old toolbar's photo branch moved UP here wholesale —
// crop, replace, remove-background, filters link, frame shape, the print-DPI
// badge, flips. The heavy machinery (crop modal, replace file input, the
// remove-BG pipeline, dblclick-to-crop) rides the mount's usePhotoActions
// hook; these are just the handler keys.

const imageRow1 = {
  id: 'image-row1',
  row: 1,
  groups: [
    {
      id: 'imageEdit',
      label: 'Photo',
      drawerSection: 'filters',
      neverCollapse: true,
      controls: [
        { id: 'imageCrop', kind: 'button', label: 'Crop (or double-click the photo)', icon: 'crop', handler: 'image.crop' },
        { id: 'imageReplace', kind: 'button', label: 'Replace image (keeps size and frame)', icon: 'replace', handler: 'image.replace' },
        // One-click AI cutout; the label mirrors busy state ('Removing…').
        { id: 'imageRemoveBg', kind: 'button', label: 'Remove the background with AI (takes a few seconds)', icon: 'wand', textFrom: 'removeBgLabel', text: 'Remove BG', handler: 'image.removeBackground' },
        // LINK into the drawer's filter panel (Effects tab hosts it).
        { id: 'imageFilters', kind: 'button', label: 'Filters', icon: 'filters', text: 'Filters', handler: 'ui.openFiltersPanel', overflowOnly: true },
      ],
    },
    {
      id: 'imageFrame',
      label: 'Frame',
      drawerSection: null,
      collapsePriority: 2,
      controls: [
        // Wiring: applyFrameShape (relative clipPath mask; 'none' clears).
        {
          id: 'frameShape', kind: 'select', label: 'Frame shape', read: 'frameShape', handler: 'image.setFrameShape', commit: 'defer',
          options: [
            { value: 'none', label: 'None' }, { value: 'circle', label: 'Circle' },
            { value: 'rounded', label: 'Rounded' }, { value: 'hexagon', label: 'Hexagon' },
            { value: 'star', label: 'Star' }, { value: 'heart', label: 'Heart' },
          ],
          fallback: 'none',
        },
      ],
    },
    {
      id: 'imageQuality',
      label: 'Print check',
      drawerSection: null,
      showWhen: 'dpiBadge',
      collapsePriority: 3,
      controls: [
        // 'Print-ready' / 'May look soft' / 'Will print blurry' at the
        // current print size — mount derives {text, tone, title} from
        // effectiveDPI (the 300-dpi WYSIWYG law's everyday face).
        { id: 'dpiBadge', kind: 'badge', label: 'Print sharpness at this size', read: 'dpiBadge' },
      ],
    },
    {
      id: 'imageFlip',
      label: 'Flip',
      drawerSection: null,
      collapsePriority: 1,
      controls: [
        { id: 'imageFlipH', kind: 'button', label: 'Flip horizontal', icon: 'flipH', handler: 'object.flipH' },
        { id: 'imageFlipV', kind: 'button', label: 'Flip vertical', icon: 'flipV', handler: 'object.flipV' },
      ],
    },
  ],
};

export default imageRow1;
